import { createContext, useContext } from "react";

type FollowedConversationsContextType = {
  refetchFollowedConversations?: () => void;
};

export const FollowedConversationsContext = createContext<FollowedConversationsContextType>({});

export const useFollowedConversations = () => useContext(FollowedConversationsContext);
